const localeEnum = {
  RU: 1,
  AM: 2,
  EN: 3,
};

Object.freeze(localeEnum);

export default localeEnum;
